import React from 'react';
import moment from 'moment';
import {InspectionStatusProvider} from '../InspectionStatusContext';
import InspectionStatus from '../InspectionStatus';

export function CreateAndStatusFormatter({createTime, shumaID, shumaStatusTypeID, shumaStatusTypeName}) {

  return (
    <div className={'d-flex flex-column align-items-center'}>
      <div className="font-weight-bolder">
        {moment(createTime).format('DD-MM-YYYY')}
      </div>
      <InspectionStatusProvider
        shumaID={shumaID}
        shumaStatusTypeID={shumaStatusTypeID}
        shumaStatusTypeName={shumaStatusTypeName}
      >
        <InspectionStatus/>
      </InspectionStatusProvider>
    </div>
  );
}